













































import Loading from './scripts';

export default Loading;
